import React from 'react';
import { CloudUpload, HardDrive, X } from 'lucide-react';

export function ImportLocalDataModal({
  offer,
  importing = false,
  error = '',
  onImport,
  onKeepSeparate,
}) {
  if (!offer) return null;

  return (
    <div
      className="fixed inset-0 z-[95] flex items-center justify-center bg-black/45 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="import-device-data-title"
    >
      <div className="relative w-full max-w-lg rounded-3xl border border-emerald-100 bg-white p-6 shadow-2xl">
        <button
          type="button"
          onClick={onKeepSeparate}
          disabled={importing}
          className="absolute right-3 top-3 rounded-xl p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 disabled:opacity-50"
          aria-label="Keep device data separate"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="flex items-center gap-3 pr-10">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700">
            <HardDrive className="h-5 w-5" />
          </span>
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-emerald-700">This device</p>
            <h2 id="import-device-data-title" className="text-xl font-black text-slate-950">
              Import your saved data?
            </h2>
          </div>
        </div>

        <div className="mt-4 text-sm leading-6 text-slate-700">
          <p>This browser already has saved VegAI data:</p>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            {offer.favorites > 0 && (
              <li>{offer.favorites} favorite{offer.favorites === 1 ? '' : 's'}</li>
            )}
            {offer.history > 0 && (
              <li>{offer.history} history item{offer.history === 1 ? '' : 's'}</li>
            )}
            {offer.foodProfile && <li>Your Food Profile</li>}
          </ul>
          <p className="mt-2">
            VegAI can copy these into your account so they follow you to other signed-in devices.
          </p>
        </div>
        <p className="mt-2 text-sm leading-6 text-slate-600">
          Importing does not erase the browser copy. Choosing "Keep separate" leaves everything
          exactly where it is.
        </p>

        {error && (
          <p className="mt-4 rounded-2xl border border-red-200 bg-red-50 p-3 text-sm font-semibold text-red-800">
            {error}
          </p>
        )}

        <div className="mt-5 grid gap-2 sm:grid-cols-2">
          <button
            type="button"
            onClick={onImport}
            disabled={importing}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <CloudUpload className="h-4 w-4" />
            {importing ? 'Importing...' : 'Import to my account'}
          </button>
          <button
            type="button"
            onClick={onKeepSeparate}
            disabled={importing}
            className="rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Keep separate
          </button>
        </div>
      </div>
    </div>
  );
}
